import React, { memo } from 'react'
import { Alert, Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import sx from './styles'

const Toast = ({ title }) => {
  const show = true
  // const [show, setShow] = useState(true)
  // let timeout

  // useEffect(() => {
  //   timeout = setTimeout(() => {
  //     setShow(false)
  //   }, seconds)

  //   return () => {
  //     clearTimeout(timeout)
  //   }
  // }, [])

  return (
    <Box sx={sx.root}>
      {show && (
        <Alert
          icon={<CheckCircleIcon fontSize="inherit" />}
          variant="filled"
          severity="success"
        >
          <FormattedMessage id={title} />
        </Alert>
      )}
    </Box>
  )
}

export default memo(Toast)
